module.exports = __webpack_public_path__ + "static/media/notifications.94223be5.svg";